<template>
    <section class="h-100">
        <front-table :front_page="page"
                     :front_records="records"
                     :front_search="search"
                     :front_header="header"
                     :model="model"
                     @reload="handleReload"
                     @edit="handleEdit"
                     btn_review
                     @review="handleReview"

        >
        </front-table>

        <poll-review :view_mode.sync="view_mode" :single="single" show_meeting @assign="handleAssign"></poll-review>

        <!--编辑界面-->
        <div class="clearfix"></div>
    </section>
</template>

<script>
    import FrontTable from "../components/front-table";
    import FrontMixins from "../common/mixins/front-mixins";
    import PollReview from "../components/poll-review";

    export default {
        mixins: [FrontMixins],
        name: 'admin-admin',
        components: {FrontTable,PollReview},
        created() {
            this.model = 'Admin.Poll';
        },
        computed: {
        },
        methods:{
            handleEdit(id){
                this.$router.push('/poll-edit/'+id);
            },
            handleAssign(data){
                this.$api(this.model+'.Assign',data,1).then(()=>{
                    this.$notice.success('已经将该投票添加至会议中');
                });
            }
        }
    }

</script>

<style lang="scss">

</style>
